const OVERVIEW_BASE = '/';
const PROFILE_BASE = '/profile';
const SECURITY_BASE = '/security';
const CREATE_ACCOUNT_BASE = '/create';
const APPS_BASE = '/apps';
export const routes = {
    OVERVIEW: OVERVIEW_BASE,
    SECURITY: SECURITY_BASE,
    PROFILE: PROFILE_BASE,
    APPS: APPS_BASE,
    CREATE_ACCOUNT: CREATE_ACCOUNT_BASE,
    PROFILE_EDIT: `${PROFILE_BASE}/edit`,
    SECURITY_EDIT_EMAIL: `${SECURITY_BASE}/edit/email`,
    SECURITY_EDIT_PASSWORD: `${SECURITY_BASE}/edit/password`,
    SECURITY_EDIT_PHONE: `${SECURITY_BASE}/edit/phone`,
    PROFILE_EDIT_NAME: `${PROFILE_BASE}/edit/name`,
    PROFILE_EDIT_LANGUAGE: `${PROFILE_BASE}/edit/language`
};
